/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GridMasterGm } from '../../models/grid-master-gm';

export interface GetGridMasterDetails$Params {
}

export function getGridMasterDetails(http: HttpClient, rootUrl: string, params?: GetGridMasterDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GridMasterGm>>> {
  const rb = new RequestBuilder(rootUrl, getGridMasterDetails.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GridMasterGm>>;
    })
  );
}

getGridMasterDetails.PATH = '/api/GridSettings/getGridMasterDetails';
